<template>
    <div class='page'>
        <div class='page__grid grid'>
            <div class='page__grid__col grid__col'>
                <!-- <BigTitle class='page__title' :title='page.title' /> -->
                <h1 class='page__heading'>
                    <div class='page__heading__title page__heading__title--1' v-text='page.title' />
                    <div class='page__heading__title page__heading__title--2' v-text='page.title' />
                </h1>
                <div class='page__body'>
                    <div class='copy' v-html='page.content' />
                </div>
                <div v-if='page.klaviyo_list_id' class='page__newsletter'>
                    <NewsletterTier :cta-text='"Sign up"' :additional-list-id='page.klaviyo_list_id' />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import BigTitle from '^/components/elements/BigTitle.vue'
import NewsletterTier from '^/components/tiers/NewsletterTier.vue'

export default {
    name: 'PageTier',
    props: {
        page: {
            type: Object,
            required: true
        }
    },
    components: {
        // BigTitle,
        NewsletterTier
    }
};
</script>
